import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import { updateClientStatus } from '../queries/subPlans.query';
import { getUserName } from '../queries/getUser';
import { practiceDataDetails, practiceFilled, professionalDataDetails, professionalFilled, supplierDataDetails, supplierFilled, getDirectoryDetail, updateProfessionalStripeId, updateSupplierStripeId, updatePracticeStripeId } from '../queries/userData.query';
@Injectable()
export class NextTabService {
  private subject = new Subject<any>();
  data = this.subject.asObservable();
  constructor(private apollo: Apollo) { }

  updatedDataSelection(data){
    this.subject.next(data);
  }


  updateClientStatus(id,clientStatus){
    //console.log(id)
    //const updateObj = {updateObj:statusData}
    console.log(clientStatus)
      return  this.apollo.use("external").mutate({
        mutation: updateClientStatus,
        variables: {id,clientStatus}
      }).pipe(pluck('data', 'update_clients_by_pk'));
  
      
  
    }

    getUser(id:string){

      return this.apollo.use("external").subscribe({
        query : getUserName,
        variables: {id}
      }).pipe(pluck('data', 'clients_by_pk'));
  
    }

    getUserProf(id:string){

      return this.apollo.use("external").subscribe({
        query : professionalDataDetails,
        variables: {id}
      }).pipe(pluck('data', 'dental_professionals_by_pk'));
  
    }

    getUserSupplier(id:string){

      return this.apollo.use("external").subscribe({
        query : supplierDataDetails,
        variables: {id}
      }).pipe(pluck('data', 'dental_suppliers_by_pk'));
  
    }

    getUserPractice(id:string){

      return this.apollo.use("external").subscribe({
        query : practiceDataDetails,
        variables: {id}
      }).pipe(pluck('data', 'dental_practices_by_pk'));
  
    }

    updateProfessionalStripe(id: string, stripeCustomerId: string, currentPlanId: string) {
      return this.apollo.use("external").mutate({
        mutation: updateProfessionalStripeId,
        variables: { id, stripe_customer_id: stripeCustomerId, present_subscription_id: currentPlanId }
      });
    }
    
    updateSupplierStripe(id: string, stripeCustomerId: string, currentPlanId: string) {
      return this.apollo.use("external").mutate({
        mutation: updateSupplierStripeId,
        variables: { id, stripe_customer_id: stripeCustomerId, present_subscription_id: currentPlanId }
      });
    }
    
    updatePracticeStripe(id: string, stripeCustomerId: string, currentPlanId: string) {
      return this.apollo.use("external").mutate({
        mutation: updatePracticeStripeId,
        variables: { id, stripe_customer_id: stripeCustomerId, present_subscription_id: currentPlanId }
      });
    }




    getUserProfDetails(id:string){

      console.log(id)

      return this.apollo.use("external").subscribe({
        query : professionalFilled,
        variables: {id}
      }).pipe(pluck('data', 'dental_professionals_by_pk'));
  
    }

    getUserSupplierDetails(id:string){

      return this.apollo.use("external").subscribe({
        query : supplierFilled,
        variables: {id}
      }).pipe(pluck('data', 'dental_suppliers_by_pk'));
  
    }

    getUserPracticeDetails(id:string){

      return this.apollo.use("external").subscribe({
        query : practiceFilled,
        variables: {id}
      }).pipe(pluck('data', 'dental_practices_by_pk'));
  
    }

    userDirectoryDetail(id: string): Observable<any> {    
        return this.apollo.use("external").subscribe({
          query: getDirectoryDetail,
          variables: { id }
        }).pipe(pluck('data', 'directories'));
    
      }





}
